if (window.screen.width > 767) {
  $(document).ready(function(){
    $(".mobile-information").remove();
  });
}

$(document).ready(function(){
    $('.mobile-information .slick-item').slick({
        slidesToShow: 4,
        arrows: true,
        infinite: false,
        swipe: true,        // Disables swipe
        touchMove: true,
         responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow:6 
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 5
            }
          }
      ]
    });
$("#labels-container input:checked + label").trigger("click");
});


$(document).on('click', '.input-row.selected-image', function () {
  if ($('.input-row-slider:visible').length) {
    //alert("hide");
    setTimeout(function () {
      $('.input-row-slider').slideUp(500);
    }, 200); // 500 milliseconds = 0.5 second
  } else {
    //alert("show");
    setTimeout(function () {
      //$(".slick-next").trigger("click");
      $('.mobile-information .input-row-slider').slideDown(500, function () {
        // Refresh slick after it's visible
        $('.mobile-information .slick-item').slick('setPosition');
      });
    }, 300);
  }
});

$(document).on('click', '.slick-item-slide', function () {
   const imgSrc = $(this).find('.opt-label__media img').attr('src');
  $('.input-row.selected-image img').attr('src', imgSrc);
  
});

$(document).on('click', '.mobile-information .btn ', function () {
  $(".detail buy-buttons .btn").trigger("click");
});

$(window).on("scroll", function () {
    const scrollTop = $(this).scrollTop();
    const footerTop = $('#pagefooter').offset().top;
    const windowHeight = $(window).height();

    if (scrollTop + windowHeight >= footerTop) {
        // Near or overlapping the footer
        $('.mobile-information').addClass('visibility');
        $('.mobile-button-container').addClass('visibility');
    } else {
        $('.mobile-information').removeClass('visibility');
        $('.mobile-button-container').removeClass('visibility');
    }
});

$(window).on('load', function(e) {
  if ($('.input-row-slider:visible').length) {
    setTimeout(function () {
      const $el = $('.mobile-information .input-row-slider');
      $el.slideUp(500);
    }, 300);
  }
});

  document.addEventListener("DOMContentLoaded", function () {
    var isAndroid = /Android/i.test(navigator.userAgent);
    if (isAndroid) {
      document.body.classList.add("android-device");
    }
  });